import { pluralRu } from '../myPrices/pluralRu'

export type ImportProgressStage = 'analyzing' | 'parsing' | 'done'

type ImportProgressProps = {
  stage: ImportProgressStage
  processedRows?: number
  totalRows?: number
}

/**
 * Что происходит с прайсом, пока пользователь ждёт:
 * загрузка файла — «Начинаем анализ прайс-листа» (бегущая полоса, шаг короткий);
 * подтверждение — «Разобрали N позиций из M» (ход фоновой задачи ядра);
 * конец — «Разбор закончен».
 */
export const ImportProgress = ({ stage, processedRows = 0, totalRows = 0 }: ImportProgressProps) => {
  const total = Math.max(0, totalRows)
  const processed = Math.min(Math.max(0, processedRows), total || processedRows)
  const percent = stage === 'done' ? 100 : total > 0 ? Math.round((processed / total) * 100) : 0
  const title =
    stage === 'analyzing'
      ? 'Начинаем анализ прайс-листа'
      : stage === 'done'
        ? 'Разбор закончен'
        : total > 0
          ? `Разобрали ${processed} ${pluralRu(processed, 'позицию', 'позиции', 'позиций')} из ${total}`
          : 'Разбираем позиции…'
  const determinate = stage !== 'analyzing'
  const progressLabel = stage === 'parsing' && total > 0 ? `${percent}%` : null
  return (
    <div className={`market-import-progress market-import-progress--${stage}`} role="status" aria-live="polite">
      <p className="market-import-progress__title">
        {stage === 'done' ? <CheckIcon /> : <span className="market-spinner" aria-hidden="true" />}
        <span>{title}</span>
      </p>
      {progressLabel ? <span className="market-import-progress__percent">{progressLabel}</span> : null}
      <div
        className="market-import-progress__track"
        role="progressbar"
        aria-label="Ход разбора прайса"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={determinate ? percent : undefined}
      >
        <div
          className={`market-import-progress__bar${determinate ? '' : ' market-import-progress__bar--indeterminate'}`}
          style={determinate ? { width: `${percent}%` } : undefined}
        />
      </div>
    </div>
  )
}

const CheckIcon = () => (
  <svg className="market-import-progress__check" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" />
  </svg>
)
